import React from "react";
import { Box, Button, Text } from "@mantine/core";
import { ContextModalProps, openContextModal } from "@mantine/modals";
import { useTranslation } from "react-i18next";

export const InfoModal = ({ context, id, innerProps }: ContextModalProps<{ modalBody: React.ReactNode }>) => {
	const { t } = useTranslation();

	return (
		<>
			<Box>{innerProps.modalBody}</Box>
			<Button fullWidth mt="md" onClick={() => context.closeModal(id)}>
				{t("button_close")}
			</Button>
		</>
	);
};

export const openInfoModal = (message: React.ReactNode) =>
	openContextModal({
		modal: "info",
		innerProps: {
			modalBody: message
		},
		withCloseButton: false
	});
